var React = require('react');

function Truck (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 0a3 3 0 012.82 2h4.58c1.41 0 2.62.969 2.92 2.349l.02.141.47 6.26c.07.82-.21 1.66-.78 2.28-.32.35-.72.609-1.15.779A2.995 2.995 0 0126 16a3 3 0 01-2.82-2h-8.36A3 3 0 0112 16a3 3 0 01-2.82-2H6V9H3V7h3V3c0-1.651 1.35-3 3-3zm6 12c-.55 0-1 .45-1 1 0 .549.45 1 1 1s1-.451 1-1c0-.55-.45-1-1-1zm-14 0c-.55 0-1 .45-1 1 0 .549.45 1 1 1s1-.451 1-1c0-.55-.45-1-1-1zm-8-1v2H0v-2h4zm20-7h-1v8h.18A3 3 0 0126 10c1.13 0 2.13.639 2.64 1.57.14-.19.19-.42.17-.66L28.67 9H24V4zm-3 5H8v3h1.18A3 3 0 0112 10a3 3 0 012.82 2H21V9zm6.4-5H26v3h2.53l-.17-2.281A.997.997 0 0027.4 4zM20 2H9c-.55 0-1 .45-1 1v4h13V3c0-.55-.45-1-1-1zM4 2v2H0V2h4z","fillRule":"evenodd"}));
}

Truck.defaultProps = {"width":"31","height":"16"};

module.exports = Truck;

Truck.default = Truck;
